// Miky Motorsport - post-processing pipeline (pmndrs/postprocessing)
// Poradi: Render -> SSAO(M6) -> Bloom -> Vignette -> ToneMapping(ACES) -> SMAA(posledni)
// POZN: pri pouziti ToneMappingEffect musi byt renderer.toneMapping = NoToneMapping
//       (jinak dvojity tonemapping) - resi se v scene.setupPost().
import {
  EffectComposer,
  RenderPass,
  EffectPass,
  BloomEffect,
  VignetteEffect,
  ToneMappingEffect,
  ToneMappingMode,
  SMAAEffect,
  SMAAPreset,
} from 'postprocessing';

export class PostFX {
  constructor(renderer, scene, camera) {
    this.composer = new EffectComposer(renderer);
    this.composer.addPass(new RenderPass(scene, camera));

    this.bloom = new BloomEffect({
      intensity: 0.42,
      luminanceThreshold: 0.88,    // jen vyrazne svetla (svetla/neony), ne jen jasny lak
      luminanceSmoothing: 0.3,
      mipmapBlur: true,
      radius: 0.62,
    });
    this.vignette = new VignetteEffect({ darkness: 0.42, offset: 0.34 });
    // AgX: moderni filmovy tonemapping - jemny rolloff highlightu, syte barvy se neprepali
    this.tone = new ToneMappingEffect({ mode: ToneMappingMode.AGX });
    this.smaa = new SMAAEffect({ preset: SMAAPreset.HIGH });

    // SMAA jako posledni (anti-aliasing az na finalnim obraze)
    this.composer.addPass(new EffectPass(camera, this.bloom, this.vignette, this.tone));
    this.composer.addPass(new EffectPass(camera, this.smaa));
  }

  setSize(w, h) {
    this.composer.setSize(w, h);
  }

  // Sila vignety (A5: rizena rychlosti pro pocit rychlosti). VignetteEffect ma settable darkness.
  setVignette(darkness) {
    if (this.vignette) this.vignette.darkness = darkness;
  }

  render(dt) {
    this.composer.render(dt);
  }

  dispose() {
    this.composer.dispose();
  }
}
